function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 1,
  width: 10.5002,
  height: 1.00002,
  rx: 0.500009,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 4.5,
  width: 10.5002,
  height: 1.00002,
  rx: 0.500009,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 8,
  width: 5.5001,
  height: 1.00002,
  rx: 0.500009,
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.2
});

function SvgNoteicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteicon);
export default __webpack_public_path__ + "static/media/note.icon.0166e073.svg";
export { ForwardRef as ReactComponent };